/**
 * Route-level loading skeleton. Shown while a lazy route chunk downloads, in
 * place of the old plain "Loading…" text, so the page has structure straight
 * away instead of a blank flash.
 */
const Bar = ({ className = '' }: { className?: string }) => (
  <div className={`rounded bg-white/10 motion-safe:animate-pulse ${className}`} />
);

const RouteSkeleton = () => (
  <div
    className="relative z-10 min-h-dvh px-4 sm:px-6 py-6"
    role="status"
    aria-live="polite"
    aria-busy="true"
  >
    <span className="sr-only">Loading page…</span>

    {/* Header line */}
    <div className="flex items-center justify-between gap-4 mb-8">
      <Bar className="h-8 w-40" />
      <div className="flex items-center gap-2">
        <Bar className="h-8 w-8 rounded-full" />
        <Bar className="h-8 w-24" />
      </div>
    </div>

    {/* Title block */}
    <div className="max-w-3xl space-y-3 mb-10">
      <Bar className="h-9 w-2/3" />
      <Bar className="h-4 w-1/2" />
    </div>

    {/* Content cards */}
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {Array.from({ length: 6 }).map((_, i) => (
        <div
          key={i}
          className="rounded-xl border border-white/10 bg-white/[0.04] p-5 space-y-3"
        >
          <Bar className="h-5 w-1/2" />
          <Bar className="h-3 w-full" />
          <Bar className="h-3 w-4/5" />
          <Bar className="h-24 w-full" />
        </div>
      ))}
    </div>
  </div>
);

export default RouteSkeleton;
